import SerialNumberGrid from './SerialNumberGrid.vue';

export default SerialNumberGrid;
